const accordionsHolders = document.querySelectorAll(".js-accordions");

if (accordionsHolders && !!accordionsHolders.length) {
  accordionsHolders.forEach((holder) => {
    const accordions = holder.querySelectorAll(".accordion-faq");

    accordions[0].classList.add("show-text");

    accordions.forEach((accordion) => {
      const accordionBtn = accordion.querySelector(".accordion__header");
      const panel = accordion.querySelector(".accordion__panel");
      accordionBtn.addEventListener("click", () => {
        accordion.classList.toggle("show-text");
        panel.style.maxHeight = panel.scrollHeight + "px";
        !accordion.classList.contains("show-text")
          ? (panel.style.maxHeight = null)
          : (panel.style.maxHeight = panel.scrollHeight + 40 + "px");
      });
    });
  });
}
